import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SportCountriesListImpl from './sport-countries-list.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Countries of a sport, sorted alphabetically. Each country is collapsed by default and unfolds to
 * reveal the leagues it holds. Only one country is unfolded at a time.
 *
 * @class SportCountriesList
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SportCountriesList` prop types.
 *
 * @property {string} sportId - Id of the sport the countries belong to.
 * @property {string} [groupId] - Container id holding all competitions of the sport, grouped by country.
 * @property {Function} [onNavigate] - Called after the user triggers navigation to a league.
 *
 * @memberof Mojito.Applications.Sports.Search.SportCountriesList
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    groupId: PropTypes.string,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    onNavigate: noop,
};

export default UIView('SportCountriesList', SportCountriesListImpl, propTypes, defaultProps);
